var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "description text-uppercase" }, [
    _c("strong", [
      _vm._v(
        "\n    " +
          _vm._s(
            _vm.$resourceString[
              "product.details.specifications.product.vrating"
            ]
          ) +
          ":\n  "
      )
    ]),
    _vm._v(" "),
    _c("ul", { staticClass: "list-unstyled" }, [
      _c("li", { staticClass: "v-rating" }, [
        _vm._v(
          "\n      " +
            _vm._s(_vm.selectedColor.colorVariationLevel.code) +
            " -\n      " +
            _vm._s(_vm.selectedColor.colorVariationLevel.description) +
            "\n\n      "
        ),
        _c(
          "span",
          {
            staticClass: "ml-3 color-variant-info",
            on: { mouseover: _vm.mouseover, mouseleave: _vm.mouseleave }
          },
          [_vm._v("\n        ?\n      ")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showCard,
                expression: "showCard"
              }
            ],
            staticClass: "rating-content-card",
            attrs: { id: "hovercard" },
            on: { mouseover: _vm.mouseover, mouseleave: _vm.mouseleave }
          },
          [
            _c("div", { staticClass: "description text-uppercase" }, [
              _c("strong", [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm.$resourceString[
                        "product.details.specifications.product.vrating.heading"
                      ]
                    ) +
                    ":\n          "
                )
              ]),
              _vm._v(" "),
              _c(
                "ul",
                { staticClass: "list-unstyled" },
                _vm._l(_vm.vrating, function(rating) {
                  return _c("li", { key: rating }, [
                    _c("strong", [_vm._v(" " + _vm._s(rating) + " : ")]),
                    _vm._v(
                      "\n              " +
                        _vm._s(
                          _vm.$resourceString[
                            "product.details.specifications.product.vrating." +
                              rating
                          ]
                        ) +
                        "\n            "
                    )
                  ])
                }),
                0
              ),
              _vm._v(" "),
              _c("img", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.specification,
                    expression: "!specification"
                  }
                ],
                staticClass: "w-100",
                attrs: { src: _vm.ratingImageUrl, alt: "v-rating level" }
              })
            ])
          ]
        )
      ])
    ]),
    _vm._v(" "),
    _c("img", {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.specification,
          expression: "specification"
        }
      ],
      staticClass: "w-50",
      attrs: { src: _vm.ratingImageUrl, alt: "v-rating level" }
    }),
    _vm._v(" "),
    _vm.specification
      ? _c("p", { staticClass: "rating-desctiption" }, [
          _vm._v(
            "\n    " +
              _vm._s(
                _vm.$resourceString[
                  "product.details.specifications.product.vrating.description"
                ]
              ) +
              "\n  "
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }